import { render, staticRenderFns } from "./recipientsDetail.vue?vue&type=template&id=377dd50e&scoped=true&"
import script from "./recipientsDetail.vue?vue&type=script&lang=js&"
export * from "./recipientsDetail.vue?vue&type=script&lang=js&"
import style0 from "./recipientsDetail.vue?vue&type=style&index=0&id=377dd50e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377dd50e",
  null
  
)

export default component.exports